import classNames from "classnames";
import { NoteBoxProps } from "./type";

export default function NoteBox(props: NoteBoxProps) {
  return (
    <div
      className={classNames(
        "noteBox",
        props.className,
        { "noteBox--stylised": props.isStylised },
        { "noteBox--inlined": props.isInlined }
      )}>
      <div className="noteBox_content">{props.children}</div>
    </div>
  );
}
